import { Carousel } from 'react-responsive-carousel';
import { observer } from 'mobx-react-lite';
import { Embed, Image } from 'semantic-ui-react';
import { useStore } from './../../../../app/stores/store';
import { ModelViewerElement } from '@google/model-viewer';
import ReactImageMagnify from 'react-image-magnify';
import './styles.css';
import { useEffect, useState } from 'react';
import PDFViewer from '../../PDFViewer';
// import { PdfLoader, PdfHighlighter, Comment, ScaledPosition } from 'react-pdf-highlighter';
// import '@react-pdf-viewer/core/lib/styles/index.css'; 

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'model-viewer': Partial<ModelViewerElement>;
    }
  }
}

// interface IHighlight {
//   id: string;
//   position: ScaledPosition;
//   content: {
//     text?: string;
//     image?: string;
//   };
//   comment: Comment; // Assuming Comment is a specific type defined elsewhere
// }

function VideoPlayComponent({
  preview,
  proxy,
}: {
  preview: string;
  proxy: string;
}) {
  const { mediaAssetStore, commonStore, userStore } = useStore();
  const [largeUrl, setLargeUrl] = useState<string[]>([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);
  // const [highlights, setHighlights] = useState<IHighlight[]>([]);

  const handleThumbnailClick = (index: number) => {
    setSelectedImageIndex(index);
  };
  // const Spinner = () => <div>Loading...</div>;

  // const onSelectionFinished = (
  //   position: ScaledPosition,
  //   content: { text?: string; image?: string },
  //   hideTipAndSelection: () => void,
  //   transformSelection: () => void
  // ): JSX.Element | null => {
  //   console.log("Selection finished:", { position, content });
  //   // Your logic here to handle the selected text
  
  //   // Return an element or null
  //   return null; // You can return JSX.Element or null based on your logic
  // };
  


  useEffect(() => {
    if (
      userStore.user?.customerName &&
      ['Isha Foundation', 'Museum']?.includes(userStore.user?.customerName)
    ) {
      const temp = preview?.split('|') || [];
      const largeUrls = temp.map((image) => {
        const parts = image.split('/');
        const fileName = parts.pop();
        const separator = parts.length > 0 ? '/' : '';
        const urlWithoutTrailingSlash = parts.join('/');
        return `${urlWithoutTrailingSlash}${separator}L_${fileName}`;
      });
      setLargeUrl(largeUrls);
    }
  }, [preview, userStore.user?.customerName]);

  return (
    <>
      <div style={{ marginBottom: '16px' }}>
        {(preview?.split('|')?.length || 0) > 1 ? (
          <>
            <Carousel
              className="carousel-wrapper"
              selectedItem={selectedImageIndex}
              showIndicators={false}
            >
              {(preview?.split('|') || [])?.map((smallImage, index) => (
                <div className="magnify-container">
                  <ReactImageMagnify
                    {...{
                      smallImage: {
                        alt: 'maginify image',
                        isFluidWidth: true,
                        src: smallImage || '',
                        // width: 200,
                        // height: 200,
                      },
                      largeImage: {
                        src: largeUrl[index] || '',
                        width: 1400,
                        height: 1400,
                      },
                      // lensStyle: {
                      //   height: '10%',
                      //   // background: 'red'
                      //   display: 'flex'
                      // },
                      // lensComponent: lensComponent,  width: '10%',
                      //
                      enlargedImageContainerClassName: 'largeImageContainer',
                      shouldUsePositiveSpaceLens: false,
                      enlargedImagePosition: 'beside',
                      enlargedImagePortalId: 'portal',
                      imageClassName: 'smallImageClassName',
                    }}
                  />
                </div>
                // <div>
                //   <img
                //     src={
                //       commonStore.devEnv &&
                //       !image.includes('https://res.cloudinary.com')
                //         ? image.split('build')?.[1]
                //         : image
                //     }
                //     alt={'images'}
                //   />
                // </div>
              ))}
            </Carousel>
            <div
              style={{ display: 'flex', justifyContent: 'left', marginTop: 10 }}
            >
              {(preview.split('|') || [])?.map((thumb, thumbIndex) => (
                <div
                  key={thumbIndex}
                  onClick={() => handleThumbnailClick(thumbIndex)}
                  style={{
                    width: '80px',
                    height: 'auto',
                    marginRight: '5px',
                    cursor: 'pointer',
                    border:
                      thumbIndex === selectedImageIndex
                        ? '2px solid #007BFF'
                        : 'none',
                  }}
                >
                  <img
                    src={thumb}
                    alt={`Thumbnail ${thumbIndex + 1}`}
                    style={{ width: '100%', height: 'auto' }}
                  />
                </div>
              ))}
            </div>
          </>
        ) : /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(preview || '') ? (
          <>
            {userStore.user?.customerName &&
            ['Isha Foundation', 'Museum']?.includes(
              userStore.user?.customerName,
            ) ? (
              <div className="magnify-container">
                <ReactImageMagnify
                  {...{
                    smallImage: {
                      alt: 'maginify image',
                      isFluidWidth: true,
                      src: preview || '',
                      // width: 200,
                      // height: 200,
                    },
                    largeImage: {
                      src: Array.isArray(largeUrl) ? largeUrl[0] : '',
                      width: 1400,
                      height: 1400,
                    },
                    // lensStyle: {
                    //   height: '10%',
                    //   // background: 'red'
                    //   display: 'flex'
                    // },
                    // lensComponent: lensComponent,  width: '10%',
                    //
                    enlargedImagePosition: 'beside',
                    imageClassName: 'single_smallImageClassName',
                    enlargedImageContainerClassName:
                      'single_largeImageContainer',
                    shouldUsePositiveSpaceLens: false,
                  }}
                />
              </div>
            ) : (
              <Image
                alt={'image'}
                style={{
                  maxHeight: '75vh',
                  minHeight: '60vh',
                  margin: 'auto',
                  // width: '100%',
                }}
                src={
                  commonStore.devEnv &&
                  !preview?.includes('https://res.cloudinary.com')
                    ? preview?.split('build')?.[1]
                    : preview
                }
              />
            )}
          </>
        ) : ['BroekmanLogistics', 'Broekman Logistics', 'TNCA']?.includes(
            userStore.user?.customerName as string,
          ) ? (
          // <object
          //   aria-labelledby="pdf"
          //   data={preview}
          //   width="100%"
          //   height="500"
          // ></object>
          preview ?
          (<PDFViewer pdfUrl={preview}/>) : <>No PDF to Display</>
        ) : (
          <>
            {proxy?.length ? (
              <Embed
                style={{ width: '100%' }}
                id={proxy !== null ? proxy : ''}
                placeholder={preview}
                source="youtube"
                onClick={mediaAssetStore.setShowHideMediaAssetTitle}
              />
            ) : /\.(glb)$/i.test(preview || '') ? (
              <div className="model-view-container">
                <model-viewer
                  alt="3D model"
                  style={
                    { width: '700px', height: '700px' } as CSSStyleDeclaration
                  }
                  // src='../assets/glb_dino.glb'
                  src={preview}
                  ar
                  environment-image="../assets/thumbnail.png"
                  poster="../assets/thumbnail.png"
                  shadow-intensity="1"
                  camera-controls
                  touch-action="pan-y"
                />
              </div>
            ) : (
              <video
                width="100%"
                controls
                style={{ maxHeight: '75vh', minHeight: '60vh' }}
                className={
                  commonStore.filterModeZero.includes('AVLAVB16')
                    ? 'component-isDisabled'
                    : ''
                }
              >
                <source src={preview} type="video/mp4" />
              </video>
            )}
          </>
        )}
      </div>
      <div id="portal" className="portal" />
    </>
  );
}

export default observer(VideoPlayComponent);
